import { Environment } from './environment.type';

export const environment: Environment = {
  env: 'dev',
  production: false,
  api: 'https://api.backoffice.t4assistant.k8s.touch4dev.net',
  aiMessageAuthorId: '62f9e8235f238b000709e84d',
  azureSsoUrl: '',
};
